import React, { Component } from 'react';
import './AirButton.css';
export default class AirButton extends Component {
  render() {
    return (
      <div
        {...this.props}
        className={`AirButton ${this.props.className || ''} ${this.props.size || 'small'} ${!!this.props.icon ? 'withIcon' : ''} ${
          this.props.hasOwnProperty('light') ? 'light' : 'dark'
        }`}
        onClick={!this.props.disabled ? this.props.onClick : undefined}
        style={{ ...{ color: this.props.color }, ...this.props.style }}
      >
        <div className="buttonInner">
          <div className="bg" style={{ backgroundColor: this.props.bgcolor }} />
          <div>
            {this.props.icon}
            {this.props.size === 'large' && (
              <div className="label" style={{ margin: 0 }}>
                {this.props.label}
              </div>
            )}
          </div>
        </div>
        {this.props.size !== 'large' && (
          <div className="label" style={{ margin: 0 }}>
            {this.props.label}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirButton/AirButton.js